/**
 * API client for the public new-parent form (/new-parent-form) — the
 * parent-filled alternative to Visitor Entry, reached by a per-centre QR.
 *
 * Backend: oh_users PublicParentForm*API. Both endpoints are open (no auth is
 * attempted), so a stale Alfred token on the device can never 401 the parent.
 * `apiEndpoints.X` stays inside the function bodies (TDZ-safety).
 */
import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { get, post } from '../request'

// { centres: [{uuid, code, name}], visit_purposes: [], awareness_sources: [] }
const fetchNewParentFormOptions = async () => {
  try {
    const response = await get(
      `${apiEndpoints.user}/public/new-parent-form/options/`
    )
    return response.data
  } catch (error) {
    sentryLogger(error)
    throw error
  }
}

// Type-ahead over the schools already in our table: { results: [{uuid, name, area}] }
const searchNewParentFormSchools = async (search) => {
  try {
    const response = await get(
      `${
        apiEndpoints.user
      }/public/new-parent-form/schools/?search=${encodeURIComponent(search)}`
    )
    return response.data
  } catch (error) {
    sentryLogger(error)
    throw error
  }
}

const submitNewParentForm = async (payload) => {
  try {
    const response = await post(
      `${apiEndpoints.user}/public/new-parent-form/`,
      payload
    )
    return response.data
  } catch (error) {
    sentryLogger(error)
    throw error
  }
}

export {
  fetchNewParentFormOptions,
  searchNewParentFormSchools,
  submitNewParentForm
}
